import React from 'react';
import Skeleton from 'react-loading-skeleton';
import { UserAuth } from '../../context/AuthContext';



function WelcomeBanner({ countRemaining, user, loading }) {
  const {  logOut } = UserAuth();




  return (
    <div className="rounded-lg bg-gradient-to-r from-blue-500 to-teal-400   flex justify-between items-center relative bg-indigo-200 p-4 sm:p-6  overflow-hidden mb-8">
      {/* Content */}
      <div className="relative ">
        <h1 className="text-2xl md:text-3xl text-white font-bold mb-1">Hey there, {user?.displayName}👋</h1>
        {loading ? (<div className="w-20"><Skeleton count={1} /> </div>) : (<p className="text-white">You have <span className="font-semibold text-cyan-50">{countRemaining}</span> usage count remaining.</p>)}

<a className='font-extrabold text-transparent italic text-xl bg-clip-text bg-gradient-to-r from-[#5a6880] to-[#410034]' href="https://www.figma.com/community/plugin/1187783142455654091">Note:Copy and paste your api key into the plugin!</a>

      </div>

<button onClick={logOut} className="bg-[#3D84F4]  py-1 text-sm md:text-base md:py-2 hover:bg-[#337df3]  text-white font-bold  px-4 rounded-lg">
  Log out
</button>
    </div>
  );
}

export default WelcomeBanner;
